import { memo } from "react";
import Box from "@mui/material/Box";
import { Outlet, useParams } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";
import { Filters } from "consts/onboarding";
import Resource from 'ui/layouts/Resource';
import type { ApplicationDetailProps } from "./types";
import {
    SendApplicationDecision,
    ApplicationDetailHeader,
    Stepper,
    ApplicationStepStatusAnalytics
} from "./widgets";
import ApplicationDetailProvider from "./ApplicationDetailProvider";

const ApplicationDetail = ({
    name,
    href,
    icon,
    children,
    steps
}: ApplicationDetailProps) => {
    const params = useParams();

    return (
        <ApplicationDetailProvider
            steps={steps}
        >
            <Resource
                sx={{
                    position: 'absolute',
                    inset: 0,
                    bgcolor: 'background.default',
                    transform: 'translateX(100%)',
                    animation: 'slideLeft .3s ease-in-out forwards',
                    height: '100%'
                }}
                breadcrumbsProps={{
                    heading: 'Onboarding',
                    links: [
                        {
                            name: 'Applications',
                            href: WebRoutes.Onboarding.Applications.Index
                        },
                        {
                            name,
                            href,
                            icon
                        },
                        {
                            name: params[Filters.pki]
                        }
                    ]
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'minmax(400px, 20%) 1fr',
                        gap: 2
                    }}
                >
                    <Box>
                        <Stepper>
                            {children}
                        </Stepper>
                        <ApplicationStepStatusAnalytics />
                        <SendApplicationDecision
                            sx={{
                                mt: 10
                            }}
                        />
                    </Box>
                    <Box>
                        <ApplicationDetailHeader />
                        <Outlet />
                    </Box>
                </Box>
            </Resource>
        </ApplicationDetailProvider>
    );
};

export default memo(ApplicationDetail);
